<template>
  <div class="StoreWallateRecharge">
    <div class="StoreWallateRechargeTitle">
      <el-page-header @back="goBack" content=""> </el-page-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'moneyManage' }"
          ><span class="titleText">财务管理</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ name: 'storeWithdrawal' }"
          ><span class="titleText">店铺余额提现</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>

    <div v-loading="btnLoading" class="mainBox">
      <div class="mainBoxForm">
        <el-form
          ref="form"
          size="mini"
          :model="storeWithdrawalForm"
          label-width="120px"
        >
          <el-form-item label="提现店铺：">
            <div class="s_name skyblue">
              {{ companyInfo.s_name }}
            </div>
          </el-form-item>
          <el-form-item label="可提现金额：">
            <div class="s_name red">{{ avl_balance }}元</div>
          </el-form-item>

          <el-form-item label="提现金额：">
            <el-input
              class="inputMoney selectedBankItem"
              placeholder="请输入提现金额"
              v-model="storeWithdrawalForm.money"
            >
              <el-button slot="append">元</el-button>
            </el-input>
          </el-form-item>

          <el-form-item label="到账银行卡号：">
            <el-select
              class="selectedBankItem"
              v-model="selectedBank"
              placeholder="请选择提现银行卡"
            >
              <el-option
                v-for="(item, index) in cardList"
                :key="index"
                :label="
                  getBankInfo(item.gate_id).label + '-' + item.bank_account
                "
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="companyInfo && companyInfo.type == 3"
            label="联系用电话号码："
          >
            <el-input
              class="inputMoney selectedBankItem"
              placeholder="请输入电话号码"
              v-model="storeWithdrawalForm.phone"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="companyInfo && companyInfo.type == 3">
            <div class="gray">
              特别说明:提现金额将到<span class="red">{{
                companyInfo.companyName
              }}</span
              >账户,请及时联系财务确认及转账
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="() => addWithdrawalCard()" type="info"
              >添加提现银行卡</el-button
            >
            <el-button @click="() => startWithdrawal()" type="info"
              >提现</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  addRecharge,
  getStoreAccountUrl,
  listBankCardUrl,
  storeWithdraw,
  childStoreWithdraw,
} from "@/api/api";
import bankList from "@/utils/bank";
export default {
  name: "StoreWallateRecharge",
  data() {
    return {
      avl_balance: 0,
      btnLoading: false,
      withDrawalcardList: null,
      formInfo2: {
        visible: false,
        info: "",
      },
      storeWithdrawalForm: {
        money: "",
        phone: "",
      },
      cardList: [],
      selectedBank: null,
    };
  },
  computed: {
    ...mapState(["userInfo", "companyInfo"]),
  },
  created() {
    this.bankList = bankList;
    this.getBalance();
    this.getcardList();
  },
  methods: {
    addWithdrawalCard() {
      // this.$alert("添加提现银行卡");
      // return;
      if (this.companyInfo && this.companyInfo.type != 9) {
        //非养殖户
        if(this.companyInfo.type==3){
          //下挂店铺提现
          this.$router.push("childStoreWidthDrawalCard");
        }else{
          //普通企业提现
            this.$router.push("storeAddWidthDrawalCard");
        }
      } else {
        this.$alert("养殖户绑卡请于肉联所app内操作");
      }
    },
    getBankInfo(gate_id) {
      let current = this.bankList.filter((item) => {
        return item.value == gate_id;
      })[0];
      return current;
    },
    getcardList() {
      let data = {
        access_token: this.userInfo.access_token,
        type: 1,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url: listBankCardUrl,
      })
        .then((res) => {
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data);
            this.cardList = res.data.data || [];
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    getBalance() {
      this.btnLoading = true;
      let data = {
        access_token: this.userInfo.access_token,
        store_id: this.userInfo.storeId,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url: getStoreAccountUrl,
      })
        .then((res) => {
          this.btnLoading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data);
            let { avl_balance } = res.data.data;
            this.avl_balance = avl_balance;
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.btnLoading = false;
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    formateTotalMoney(item) {
      if (item.fm_status == 1) {
        return item.prepayment;
      }
      if (item.fm_status == 2) {
        return (item.totalMoney - item.prepayment).toFixed(2);
      } else {
        return item.totalMoney;
      }
    },
    childCompanyEnsureWidthDrawalMoney() {
      this.btnLoading = true;
      let data = {
        access_token: this.userInfo.access_token,
        money: this.storeWithdrawalForm.money.trim(),
        card_id: this.selectedBank,
        store_id: this.companyInfo.storeId,
        store_name:this.companyInfo.s_name,
        telephone: (this.storeWithdrawalForm.phone+"").trim(),
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      console.log("data", data);
      this.$axios({ method: "post", data: param, url: childStoreWithdraw })
        .then((res) => {
          if (res.data.resultCode == 1) {
            // id=5257e62dc3e6406e8003d72d95ae1442&order_id=10006040&totalMoney=1&prepayment=0&type=6&fm_status=3&pay_flag=0&store_name=18866550002三十度佳测试&store_id=10000002956171705580
            console.log("res.data.data", res.data);
            this.storeWithdrawalForm.money = 0;
            this.storeWithdrawalForm.phone = '';
            this.$alert(`提现申请成功,提现金额将到${this.companyInfo.companyName}账户,请及时联系公司财务确认及转账!`, "成功").then(() => {
              this.$router.go(-1);
            });
          } else {
            this.btnLoading = false;
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.btnLoading = false;
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    ensureWidthDrawalMoney() {
      this.btnLoading = true;
      let data = {
        access_token: this.userInfo.access_token,
        money: this.storeWithdrawalForm.money.trim(),
        card_id: this.selectedBank,
        store_id: this.companyInfo.storeId,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      console.log("data", data);
      this.$axios({ method: "post", data: param, url: storeWithdraw })
        .then((res) => {
          if (res.data.resultCode == 1) {
            // id=5257e62dc3e6406e8003d72d95ae1442&order_id=10006040&totalMoney=1&prepayment=0&type=6&fm_status=3&pay_flag=0&store_name=18866550002三十度佳测试&store_id=10000002956171705580
            console.log("res.data.data", res.data);
            this.storeWithdrawalForm.money = 0;
            this.$alert("提现成功!", "成功").then(() => {
              this.$router.go(-1);
            });
          } else {
            this.btnLoading = false;
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.btnLoading = false;
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    startWithdrawal() {
      console.log("this.selectedBank", this.selectedBank);
      if (isNaN(this.storeWithdrawalForm.money)) {
        this.$alert("请输入有效的金额");
        return;
      }

      if (this.storeWithdrawalForm.money <= 0) {
        this.$alert("请输入有效的金额");
        return;
      }

      if (!this.selectedBank) {
        this.$alert("请选择到账银行卡号");
        return;
      }

      if (this.companyInfo && this.companyInfo.type == 3) {
        //挂名店铺提现
        if (
          !/^([0-9]{11})$/g.test((this.storeWithdrawalForm.phone + "").trim())
        ) {
          this.$alert("联系用手机号格式有误");
          return;
        }
      }


      this.$nextTick(() => {
        let bank_account = this.cardList.filter((item) => {
          return item.id == this.selectedBank;
        })[0].bank_account;

        this.$confirm(
          `确认提现${this.storeWithdrawalForm.money}元到账户${bank_account}？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            // type: "warning"
          }
        )
          .then(
            this.companyInfo && this.companyInfo.type == 3
              ? this.childCompanyEnsureWidthDrawalMoney //企业类型，挂名店铺提现
              : this.ensureWidthDrawalMoney//企业类型，非挂名店铺提现
          )
          .catch(() => {});
      });
    },
  },
};
</script>

<style scoped lang='less'>
.StoreWallateRecharge {
  padding: 10px;
}
.titleText {
  font-size: 13px;
  color: #009e96 !important;
}
.StoreWallateRechargeTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.formInfo {
  width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 13px;
  color: #009688;
  border-radius: 2px;
  margin-bottom: 10px;
  height: 20px;
}
.mainBoxForm {
}
.inputMoney {
  width: 200px;
}
.mainBox {
  margin-top: 30px;
  padding-bottom: 30px;
}
.s_name {
  font-size: 13px;
}
.selectedBankItem {
  width: 280px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/StoreWithdrawal.vue